export const MealPlanNav = {
  bindings: {
    name: '<',
    isDisabled: '<',
    mealPlanName: '@',
    shoppingListName: '@',
    onClick: '&',
  },

  template: `
    <div class="meal-plan-nav pill-toggle d-flex">
      <button class="btn btn-sm btn-pill w-100"
        ng-class="{ 'btn-primary': $ctrl.name === $ctrl.mealPlanName }"
        ng-disabled="$ctrl.isDisabled"
        ng-click="$ctrl.onClick({ name: $ctrl.mealPlanName })">
        Meal Plan
      </button>
      <button class="btn btn-sm btn-pill w-100"
        ng-class="{ 'btn-primary': $ctrl.name === $ctrl.shoppingListName }"
        ng-disabled="$ctrl.isDisabled"
        ng-click="$ctrl.onClick({ name: $ctrl.shoppingListName })">
        Shopping List
      </button>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanNav.js